<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tutors
 * Name: TutorRating
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3398-25539
 *
 * The tutor score badge: a number and a star on a blurred dark plate. Not interactive.
 * It only draws itself — positioning over the photo and visibility belong to the host
 * (per Figma, TutorPhoto/TutorProfile own showRating). Figma's size axis (md 50x20 /
 * lg 59x24) is resolved responsively: md metrics up to 1023px, lg from media_desktop.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui (dsGap).
 */
// types
import type { TutorRatingProps } from '../types/interfaces'
// components
import { Icon } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'TutorRating',
})

defineProps<TutorRatingProps>()
</script>

<template>
  <span class="tutor-rating">
    <span class="tutor-rating__value btly-text-title-s lg:btly-text-title-m">{{ rating }}</span>
    <Icon
      name="star"
      size="xs"
      weight="solid"
      color="inverse"
    />
  </span>
</template>

<style lang="scss" scoped src="../styles/_tutor-rating.scss" />
